
const {
    REACT_APP_API_QC,
    REACT_APP_API_PROXY_QC
} = process.env;


let config = {
    // QC_API_URL: REACT_APP_API_QC || "http://localhost:6012/qcApi",
    QC_API_URL: REACT_APP_API_PROXY_QC
}

export default config;